<template>
  <div id="word-editor">
    <el-dialog
        :title="wordDialogText"
        :visible.sync="isAddWordShow"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :show-close="false"
        width="650px">
      <div>
        <el-form label-width="100px" size="medium">
<!--          <el-form-item label="模块" :required="true">-->
<!--            <el-cascader-->
<!--                clearable-->
<!--                v-model="selectModuleIds"-->
<!--                :options="appModuleTreeData"-->
<!--                :props="{ checkStrictly: true, value: 'id', label: 'name' }"-->
<!--                :show-all-levels="true"-->
<!--                @change="() => {}" placeholder="请选择数据的模块"></el-cascader>-->
<!--          </el-form-item>-->
          <el-form-item
              label="文字" :required="true">
            <el-input v-model="wordItem.word" :show-word-limit="true" :maxlength="1"></el-input>
          </el-form-item>
          <el-form-item
              label="拼音" :required="true">
            <el-input v-model="wordItem.pinyin" :show-word-limit="true" :maxlength="10"></el-input>
          </el-form-item>
          <el-form-item
              label="词语" :required="true">
            <el-input v-model="wordItem.phrase" :show-word-limit="true" :maxlength="64"></el-input>
          </el-form-item>
          <el-form-item
              label="句子" :required="true">
            <el-input v-model="wordItem.sentence" :show-word-limit="true" :maxlength="256"
                      type="textarea"></el-input>
          </el-form-item>
          <div class="item-line"></div>
          <el-form-item
              label="视频" :required="true">
            <div class="form-item-container">
              <el-upload
                  accept="video/mp4"
                  :show-file-list="false"
                  action=""
                  :http-request="uploadVideo">
                <el-button type="primary" v-text="wordItem.videoId!==''?'更新视频':'上传视频'"></el-button>
<!--                <span class="upload-item-text" v-if="wordItem.videoName!==''"><span style="color: #222222">{{ wordItem.videoName }}</span></span>-->
                <span class="upload-item-text" v-if="wordItem.videoId!==''"><span style="color: #222222">{{ wordItem.word + '.mp4' }}</span></span>
              </el-upload>
            </div>
            <div class="form-des-text">
              MP4格式，大小不超过100M
            </div>
          </el-form-item>
          <el-form-item
              label="视频封面" :required="true">
            <div class="form-item-container">
              <el-upload
                  accept="image/jpeg,image/png,image/jpg"
                  :show-file-list="false"
                  action=""
                  :http-request="uploadVideoCover">
                <div class="video-image-upload-cover image-upload-cover">
                  <img v-if="wordItem.videoCover" :src="wordItem.videoCover" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </el-upload>
            </div>
            <div class="form-des-text">
              支持JPEG/PNG，不超过2M，推荐16:9
            </div>
          </el-form-item>
          <div class="item-line"></div>
          <el-form-item
              label="文字音频" :required="true">
            <div class="form-item-container">
              <el-upload
                  accept="audio/mpeg"
                  action=""
                  :show-file-list="false"
                  :http-request="uploadMp3">
                <el-button type="primary" v-text="wordItem.mp3Id===''?'上传音频':'更新音频'"></el-button>
<!--                <span class="upload-item-text" v-if="wordItem.mp3Name!==''">{{ wordItem.mp3Name }}</span>-->
                <span class="upload-item-text" v-if="wordItem.mp3Id!==''">{{ wordItem.word + '.mp3' }}</span>
              </el-upload>
            </div>
            <div class="form-des-text">
              MP3格式，大小不超过10M
            </div>
          </el-form-item>

          <el-form-item
              label="句子音频" :required="true">
            <div class="form-item-container">
              <el-upload
                  accept="audio/mpeg"
                  action=""
                  :show-file-list="false"
                  :http-request="uploadSentenceMp3">
                <el-button type="primary" v-text="wordItem.sentenceMp3Id===''?'上传音频':'更新音频'"></el-button>
<!--                <span class="upload-item-text" v-if="wordItem.sentenceMp3IdName!==''">{{ wordItem.sentenceMp3IdName }}</span>-->
                <span class="upload-item-text" v-if="wordItem.sentenceMp3Id">{{ '句子音频.mp3' }}</span>
              </el-upload>
            </div>
            <div class="form-des-text">
              MP3格式，大小不超过10M
            </div>
          </el-form-item>
          <div class="item-line"></div>
          <el-form-item
              label="图片" :required="true">
            <div class="form-item-container">
              <div class="image-list-preview" v-for="(item,index) in wordItem.images" :key="index">
                <img
                    style="width: 100px;height: 100px;vertical-align:middle;
                                            border-radius: 4px; object-fit: cover;border: rgba(0,0,0,.08) 1px dashed;margin-right: 5px;"
                    :src="item">
                <div class="image-action-part">
                  <span class="el-icon-view" @click="showImagePreview(item)"></span>
                  <span class="el-icon-delete" @click="doImageListItemDelete(index)"></span>
                </div>
              </div>
              <el-upload
                  v-if="wordItem.images.length<4"
                  action=""
                  style="display:inline-block;"
                  accept="image/jpeg,image/png,image/jpg"
                  :show-file-list="false"
                  :http-request="uploadPic">
                <div class="image-upload-cover">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </el-upload>
            </div>
            <div class="form-des-text">
              支持JPEG/PNG，单张不超过2M，最多4张
            </div>
          </el-form-item>
          <div class="item-line" v-if="bookList.length!==0"></div>
          <el-form-item
              v-if="bookList.length!==0"
              label="教材" :required="true">
            <el-select v-model="wordItem.bookId" @change="onBookItemSelect">
              <el-option v-for="(item,index) in bookList" :key="index" :label="item.name"
                         :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
              v-if="bookList.length!==0"
              label="归组" :required="true">
            <el-select v-model="wordItem.groupId">
              <el-option v-for="(item,index) in groupList" :key="index" :label="item.name"
                         :value="item.id"></el-option>
            </el-select>
          </el-form-item>
<!--          <el-form-item label="石头" :required="true">-->
<!--            <el-select v-model="wordItem.payWith">-->
<!--              <el-option value="0" label="免费"></el-option>-->
<!--              <el-option value="1" label="绿色石头"></el-option>-->
<!--              <el-option value="2" label="蓝色石头"></el-option>-->
<!--              <el-option value="3" label="红色石头"></el-option>-->
<!--            </el-select>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="单价" :required="true" v-if="wordItem.payWith!==null&&wordItem.payWith!=='0'">-->
<!--            <el-input-number v-model="wordItem.price" :min="1"></el-input-number>-->
<!--          </el-form-item>-->
          <div class="item-line"></div>
          <el-form-item
              label="状态" :required="true">
            <el-switch active-value="1" inactive-value="0" inactive-text="下架" active-text="上架"
                       v-model="wordItem.enable"></el-switch>
          </el-form-item>
          <el-form-item
              label="顺序" :required="true">
            <el-input-number v-model="wordItem.ord" :min="0"></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
                  <el-button @click="onWordCancel" size="medium">取 消</el-button>
                  <el-button type="primary" @click="postWord" size="medium">提 交</el-button>
                </span>
    </el-dialog>
    <el-dialog :visible.sync="imagePreviewShow">
      <img width="100%" :src="previewImageUrl" alt="图片">
    </el-dialog>
  </div>
</template>
<script>
import * as api from '../api/api'

export default {
  data() {
    return {
      isAddWordShow: false,
      wordDialogText: '',
      wordItem: {
        id: '',
        word: '',
        groupId: '',
        enable: '1',
        ord: 0,
        videoId: '',
        videoCover: '',
        images: [],
        mp3Id: '',
        mp3Name: '',
        sentenceMp3Id: '',
        sentenceMp3IdName: '',
        videoName: '',
        bookId: '',
        phrase: '',
        pinyin: '',
        sentence: '',
        price: 0,
        payWith: '0',
        moduleId: '0',
      },
      selectModuleIds: [],
      appModuleTreeData: [],
      imagePreviewShow: false,
      previewImageUrl: '',
      bookList: [],
      groupList: []
    }
  },
  methods: {
    getModuleTreeData() {
      api.getAppModuleTree().then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.appModuleTreeData = result.data;
        }
      })
    },
    listGroup(bookId) {
      api.listWordGroupSimple(bookId).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.groupList = result.data;
        }
      })
    },
    onBookItemSelect() {
      this.wordItem.groupId = '';
      this.listGroup(this.wordItem.bookId)
    },
    onWordCancel() {
      this.wordItem.id = '';
      this.wordItem.images = [];
      this.wordItem.word = '';
      this.wordItem.pinyin = '';
      this.wordItem.images.length = 0;
      this.wordItem.videoId = '';
      this.wordItem.enable = '1';
      this.wordItem.mp3Id = '';
      this.wordItem.ord = 0;
      this.wordItem.groupId = '';
      this.wordItem.videoCover = '';
      this.wordItem.mp3Name = '';
      this.wordItem.sentenceMp3Id = '';
      this.wordItem.sentenceMp3IdName = '';
      this.wordItem.videoName = '';
      this.wordItem.sentence = '';
      this.wordItem.phrase = '';
      this.wordItem.bookId = '';
      this.wordItem.payWith = '0';
      this.wordItem.price = 0;
      this.wordItem.moduleId = '0';
      this.isAddWordShow = false;
    },
    postWord() {
      //检查数据
      if (this.wordItem.word === '') {
        return this.$message.error("请输入文字.");
      }
      if (this.wordItem.word.length !== 1) {
        return this.$message.error("最多是一个字.");
      }
      if (this.wordItem.phrase === '') {
        return this.$message.error("请组词.");
      }
      if (this.wordItem.sentence === '') {
        return this.$message.error("请造句.");
      }
      if (this.wordItem.videoId === '') {
        return this.$message.error("请上传视频.");
      }
      if (this.wordItem.mp3Id === '') {
        return this.$message.error("请上传音频.");
      }
      if (this.wordItem.sentenceMp3Id === '') {
        return this.$message.error("请上传句子音频.");
      }
      if (this.wordItem.videoCover === '') {
        return this.$message.error("请上传视频封面.");
      }
      if (this.wordItem.images.length === 0) {
        return this.$message.error("请上传文字图片.");
      }
      if (this.wordItem.bookId === '') {
        return this.$message.error("请关联到教材中.");
      }
      if (this.wordItem.groupId === '') {
        return this.$message.error("请设置所属分组.");
      }

      //判断是更新还是新创建
      if (this.wordItem.id === '') {
        //新创建
        api.postWordItem(this.wordItem).then(result => {
          if (result.code === api.SUCCESS_CODE) {
            this.$message.success(result.msg);
            this.$emit("onPostWordSuccess");
            this.onWordCancel();
          } else {
            this.$message.error(result.msg);
          }
        })
      } else {
        //更新原有的
        api.updateWordItem(this.wordItem).then(result => {
          if (result.code === api.SUCCESS_CODE) {
            this.$message.success(result.msg);
            this.$emit("onPostWordSuccess");
            this.onWordCancel();
          } else {
            this.$message.error(result.msg);
          }
        })
      }
    },
    showWordEditorWithBookList(bookList, item) {
      //根据bookId去获取组显示
      this.bookList = bookList;
      //判断如果有groupId，直接去获取
      if (item !== null && item.groupId !== '') {
        this.listGroup(item.bookId);
      }
      this.showWordEditor(null, null, item ? item.groupId : null, item);
    },
    showWordEditor(bookId, moduleId, groupId, item) {
      this.selectModuleIds = [];
      this.wordItem.bookId = bookId;
      this.wordItem.groupId = groupId;
      this.wordItem.moduleId = moduleId;
      if (item) {
        this.wordItem.id = item.id;
        this.wordItem.word = item.word;
        this.wordItem.pinyin = item.pinyin;
        this.wordItem.groupId = item.groupId;
        this.wordItem.enable = item.enable;
        this.wordItem.ord = item.ord;
        this.wordItem.videoId = item.videoId;
        this.wordItem.videoCover = item.videoCover;
        this.wordItem.images = item.images;
        this.wordItem.mp3Id = item.mp3Id;
        this.wordItem.sentenceMp3Id = item.sentenceMp3Id;
        this.wordItem.mp3Name = item.mp3Name;
        this.wordItem.videoName = item.videoName;
        this.wordItem.bookId = item.bookId;
        this.wordItem.phrase = item.phrase;
        this.wordItem.sentence = item.sentence;
        this.wordItem.payWith = item.payWith;
        this.wordItem.price = item.price;
        this.wordItem.moduleId = item.moduleId;
        this.selectModuleIds.push(item.moduleId)
        this.wordDialogText = '编辑识字内容';
      } else {
        this.wordDialogText = '创建识字内容';
      }
      this.isAddWordShow = true;
    },
    showImagePreview(url) {
      this.imagePreviewShow = true;
      this.previewImageUrl = url;
    },
    doImageListItemDelete(index) {
      this.wordItem.images.splice(index, 1);
    },
    uploadVideoCover(object) {
      let formData = new FormData();
      formData.append('image', object.file);
      api.postMp4Cover(formData).then((result) => {
        if (result.code === api.SUCCESS_CODE) {
          let url = result.data;
          this.$message({
            message: '视频封面上传成功.',
            type: 'success',
            center: true
          });
          this.wordItem.videoCover = url;
        } else {
          this.$message.error(result.msg);
        }
      }).catch((err) => {
        console.log(err);
        this.$message({
          message: '上传视频封面出错',
          type: 'error',
          center: true
        })
      })
    },
    uploadMp3(object) {
      let formData = new FormData();
      formData.append('mp3', object.file);
      api.postMp3(formData).then((result) => {
        if (result.code === api.SUCCESS_CODE) {
          let url = result.data;
          this.$message({
            message: 'mp3上传成功.',
            type: 'success',
            center: true
          });
          this.wordItem.mp3Id = url;
          this.wordItem.mp3Name = object.file.name;
        } else {
          this.$message.error(result.msg);
        }
      }).catch((err) => {
        console.log(err);
        this.$message({
          message: '上传mp3出错',
          type: 'error',
          center: true
        })
      })
    },
    uploadSentenceMp3(object) {
      let formData = new FormData();
      formData.append('mp3', object.file);
      api.postMp3(formData).then((result) => {
        if (result.code === api.SUCCESS_CODE) {
          let url = result.data;
          this.$message({
            message: 'mp3上传成功.',
            type: 'success',
            center: true
          });
          this.wordItem.sentenceMp3Id = url;
          this.wordItem.sentenceMp3IdName = object.file.name;
        } else {
          this.$message.error(result.msg);
        }
      }).catch((err) => {
        console.log(err);
        this.$message({
          message: '上传mp3出错',
          type: 'error',
          center: true
        })
      })
    },
    uploadVideo(object) {
      let formData = new FormData();
      formData.append('mp4', object.file);
      api.postMp4(formData).then((result) => {
        if (result.code === api.SUCCESS_CODE) {
          let url = result.data;
          this.$message({
            message: '视频上传成功.',
            type: 'success',
            center: true
          });
          this.wordItem.videoId = url;
          this.wordItem.videoName = object.file.name;
        } else {
          this.$message.error(result.msg);
        }
      }).catch((err) => {
        console.log(err);
        this.$message({
          message: '上传视频出错',
          type: 'error',
          center: true
        })
      })
    },
    uploadPic(object) {
      let formData = new FormData();
      formData.append('image', object.file);
      api.postWordImage(formData).then((result) => {
        if (result.code === api.SUCCESS_CODE) {
          let url = result.data;
          this.$message({
            message: '文字图片上传成功.',
            type: 'success',
            center: true
          });
          this.wordItem.images.push(url);
        } else {
          this.$message.error(result.msg);
        }
      }).catch((err) => {
        console.log(err);
        this.$message({
          message: '上传文字图片出错',
          type: 'error',
          center: true
        })
      })
    },
  },
  mounted() {
    this.getModuleTreeData()
  }
}
</script>
<style scoped>
.image-action-part:hover {
  opacity: 1;
}

.image-action-part {
  position: absolute;
  display: flex;
  justify-content: space-around;
  align-items: center;
  opacity: 0;
  background: rgba(0, 0, 0, .1);
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.image-upload-cover {
  text-align: center;
  cursor: pointer;
  line-height: 100px;;
  margin-right: 20px;
  width: 100px;
  height: 100px;
  border-radius: 4px;
  border: #DCDFE6 dashed 2px;
}

.video-image-upload-cover {
  line-height: 135px;
  width: 240px;
  height: 135px;
}

.image-upload-cover img {
  width: 100%;
  height: 100%;
}

.item-line {
  border-bottom: rgba(0, 0, 0, .08) 1px dashed;
  margin-bottom: 20px;
  margin-left: 60px;
}

.upload-item-text {
  font-weight: 600;
  margin-left: 10px;
}

.image-list-preview {
  display: inline-block;
  text-align: center;
  position: relative;
}

</style>
